<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  <h3 class="modal-title">Select Division</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="overflow-x mt-3" style="width: 100%;">
    <div class="row">
      <div class="col-lg-12 mb-2">
        <div class="left inline control-label mb-1">Division</div>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="userJurisdiction" disabled>
      </div>
        <div class="division_tag row mx-0 w-100">
          <div class="col-lg-6" *ngIf="similarResult.closedIds && similarResult.closedIds.length > 0">
            <div class="control-label fw">
              Closed
            </div>
            <div class="overflow-div-2 pt-2">
              <div *ngFor="let rt of similarResult.closedIds"
                class="highlight-text-blue oveflow-div rp-highlight item-text">
                <span (click)="openEditPopup(rt)">{{rt}}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6" *ngIf="similarResult.impactAssessmentIds && similarResult.impactAssessmentIds.length > 0">
            <div class="control-label fw">Impact Assessment</div>
            <div class="overflow-div-2 pt-2">
              <div *ngFor="let rt of similarResult.impactAssessmentIds"
                class="highlight-text-blue oveflow-div rp-highlight item-text">
                <span (click)="openAssessmentPopup(rt.id)">{{rt.updatedDbId}}</span>
              </div>
            </div>
          </div>
        </div>
      <div class="col-lg-12 text-left" *ngIf="isTableLoaded">
        <div class="text-blue">
          {{endIndex}} out of {{totalCount}}
        </div>
      </div>
      <div class="col-lg-12">
        <div class="table-responsive box-shadow table-cont body-style">
          <table class="table table-fixed table-hover mb-0">
            <thead>
              <tr>
                <th class="text-center mx-width-1pr">
                  <input type="checkbox" name="All" *ngIf="!isSelectAll" (change)="selectAllItem($event)" />
                  <input type="checkbox" name="All" checked *ngIf="isSelectAll" (change)="selectAllItem($event)" />
                </th>
                <th class="col-lg-2 mx-width-12pr" (click)="sortItem('id')">Id
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'id' && !filters.IsDesc),
                  'fa-sort-amount-desc': (filters.SortKey === 'id' && filters.IsDesc) }" aria-hidden="true">
                  </i>
                </th>
                <th class="col-lg-2 mx-width-12pr" (click)="sortItem('regulator')">Regulator
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'regulator' && !filters.IsDesc),
                  'fa-sort-amount-desc': (filters.SortKey === 'regulator' && filters.IsDesc) }" aria-hidden="true">
                  </i>
                </th>
                <th class="col-lg-2 mx-width-12pr" (click)="sortItem('date')">Date
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'date' && !filters.IsDesc),
                  'fa-sort-amount-desc': (filters.SortKey === 'date' && filters.IsDesc) }" aria-hidden="true">
                  </i>
                </th>
                <th class="col-lg-2 mx-width-16pr" (click)="sortItem('pubType')">Pub Type
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'pubType' && !filters.IsDesc),
                  'fa-sort-amount-desc': (filters.SortKey === 'pubType' && filters.IsDesc) }" aria-hidden="true">
                  </i>
                </th>
                <th class="col-lg-3 max-width-45pr" (click)="sortItem('title')">Title
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (filters.SortKey === 'title' && !filters.IsDesc),
                  'fa-sort-amount-desc': (filters.SortKey === 'title' && filters.IsDesc) }" aria-hidden="true">
                  </i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="!isTableLoaded">
                <td> <i class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i></td>
              </tr>
              <tr *ngIf="isTableLoaded && linkedUpdates && linkedUpdates.length === 0">
                <td>No Data</td>
              </tr>
            </tbody>
            <tbody *ngIf="linkedUpdates && linkedUpdates.length > 0" style="height: 350px;">
              <tr *ngFor="let item of linkedUpdates">
                <td class="mx-width-1pr text-center" scope="row">
                  <input type="checkbox" name="All" *ngIf="!checkSelectedItem(item.id)" (change)="selectItem($event, item.id)" />
                  <input type="checkbox" name="All" checked *ngIf="checkSelectedItem(item.id)" (change)="selectItem($event, item.id)" />
                </td>
                <td class="col-lg-2 mx-width-12pr">{{item.id}}</td>
                <td class="col-lg-2 mx-width-12pr" scope="row">{{item.regulator}}</td>
                <td class="col-lg-2 mx-width-12pr" scope="row">{{item.date |
                  date:'dd-MMM-yyyy'}}</td>
                <td class="col-lg-2 mx-width-16pr tabel-td-scroll" scope="row">{{item.pubType}}</td>
                <td class="col-lg-3 max-width-45pr tabel-td-scroll" scope="row">{{item.title}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default pull-right" (click)="closeDialog()" cdkFocusInitial>Update</button>
  <button class="btn btn-sm btn-default pull-right" [mat-dialog-close]="">Cancel</button>
</div>
